// extracted by mini-css-extract-plugin
export default {"labelText":"StartAndEndTime_labelText__6OeBO","labelDisabled":"StartAndEndTime_labelDisabled__-NzIm"};